<script>
  import { translate } from "../../../i18n/i18next.js";

  export let license
</script>

<div class="title">
  {translate("generic.license.serialNumber")}: {license.serialNumber}</div>
<div class="info">
  サブライセンス: {license.subLicenses.map(subLicense => `${subLicense.moduleType} (使用可能品番数: ${subLicense.dataUsage})`)}
</div>
<div class="info">
  {translate("generic.license.validityPeriod")}:
  {#if license.validityPeriod.isValid.ok}
    {license.validityPeriod.start} - {license.validityPeriod.end}
  {:else}
    <span style="color:crimson">
      {license.validityPeriod.start} - {license.validityPeriod.end}
    </span>
  {/if}
</div>
{#if license.project}
  <div class="info">
    {translate("generic.comment")}:
    {license.project}
  </div>
{/if}
